import { useTranslation } from 'react-i18next';
import { usePopup } from '../../../providers/PopupProvider';
import CheckoutLinkPopup from '../components/CheckoutLinkPopup';
import { OrderDto } from '../../../services/Order/orderService.dto';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { generateCheckoutLink } from '../utils/checkoutLink';
import { userService } from '../../../services/User/userService';

export const useCheckoutLinkPopup = () => {
  const { showPopover, showConfirmPopover } = usePopup();
  const { t } = useTranslation('onsite');

  const showCheckoutLinkPopup = async (
    order: OrderDto,
    technicalUser: UserDetailsDto,
    refetchTechnicalUser: () => Promise<UserDetailsDto>,
    reset: boolean
  ) => {
    const processCheckoutLink = async () => {
      const checkoutLink = await generateCheckoutLink(order, technicalUser, refetchTechnicalUser, reset);
      showPopover(<CheckoutLinkPopup checkoutLink={checkoutLink} />);
      if (reset) {
        await userService.cleanupAccount(technicalUser.id, technicalUser.firstName, technicalUser.lastName);
      }
    };

    if (reset) {
      showConfirmPopover(t('order.reset-confirmation'), processCheckoutLink);
    } else {
      await processCheckoutLink();
    }
  };

  return { showCheckoutLinkPopup };
};
